import React from 'react';
import RewardCard from '../../../components/reward/card';
import HeaderList from '../../../components/reward/header-list';
import { RewardType } from '../../../types/rewards';

interface IProps {
  id: string;
  merchantName: string;
}

const RewardSection: React.FC<IProps> = ({
  id,
  merchantName
}) => {
  const rewards = [
    {
      type: 'cashback',
      title: 'Earn Cashback RM5.00',
      description: 'with every RM5.00 spent',
      multiplier: 1,
    },
    {
      type: 'point',
      title: 'Earn 100 Points',
      description: 'with every RM5.00 spent, capped at 500 points',
      multiplier: 1,
    },
    {
      type: 'stamp',
      title: 'Earn 2 Stamps',
      description: 'with every RM5.00 spent',
      multiplier: 1,
    },
    {
      type: 'cashback',
      title: 'Earn Cashback RM5.00',
      description: 'with every RM5.00 spent',
      multiplier: 6,
    },
    {
      type: 'point',
      title: 'Earn 100 Points',
      description: 'with every RM5.00 spent, capped at 500 points',
      multiplier: 10,
      disabled: true
    }
  ]

  return (
    <div className='mx-auto flex w-full max-w-[calc(100%-2rem)] flex-col gap-y-4'>
      <HeaderList
        title='My Rewards'
        description={
          'Redeem rewards instantly at the store when you pay with AyeFace'
        }
        href={`/my-rewards-hub/${id}/rewards`}
      />
      <div className='flex flex-wrap px-2'>
        {rewards.map((reward) => {
          return (
            <div className='basis-full py-2 sm:basis-1/2 lg:basis-1/3 sm:pr-2'>
              <RewardCard
                merchantName={merchantName}
                type={reward.type as RewardType}
                title={reward.title}
                description={reward.description}
                multiplier={reward.multiplier}
                disabled={reward.disabled}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default RewardSection;